module.exports = __webpack_public_path__ + "carousel_05_img_01.png?25894481c620f96dac7615c466be80ea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel_05_img_01.png
// module id = 162
// module chunks = 0